/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./scripts/common.js":
/*!***************************!*\
  !*** ./scripts/common.js ***!
  \***************************/
/***/ (() => {

if (document.body.contains(document.querySelector('fieldset.variant-option-size'))) {
  var fieldset = document.querySelector('fieldset.variant-option-size');
  var productInfo = document.querySelector('.product-info');
  var sizeInput = fieldset.querySelectorAll('label');
  var quickAdd = document.querySelector('.product-quick-add');
  if (fieldset.classList.contains('size-disabled')) {
    productInfo.classList.add('size-product-info');
    quickAdd ? quickAdd.classList.add('hidden') : console.log('');
    setTimeout(function () {
      var buyButton = document.querySelector('.size-product-info form .buy-buttons');
      var clickChecker = 0;
      buyButton.addEventListener('click', function (e) {
        clickChecker++;
        var sizeError = document.createElement('div');
        sizeError.classList.add('size-error', 'badge', 'badge--on-sale');
        sizeError.innerHTML = 'Please select size first';
        if (clickChecker == 1) {
          buyButton.parentNode.insertBefore(sizeError, buyButton.nextSibling);
          //show for 10 sec 
          setTimeout(function () {
            clickChecker = 0;
            sizeError.remove();
          }, 10000);
        }
      });
    }, 50);
  }
  sizeInput.forEach(function (input) {
    input.addEventListener('click', function (e) {
      console.log(e.target.closest('.variant-option-size'));
      if (fieldset.classList.contains('size-disabled')) {
        fieldset.querySelector('legend').nextElementSibling.innerHTML = input.textContent;
        productInfo.classList.remove('size-product-info');
        fieldset.classList.remove('size-disabled');
        quickAdd.classList.remove('hidden');
      }
    });
  });

  // let variantExceptSize = document.querySelectorAll('.variant-picker__option:not(.variant-option-size) label');
  // variantExceptSize.forEach((label)=> {
  //     label.addEventListener('click',(e)=> {
  //         setTimeout(() => {
  //             let currentUrl = window.location.href;
  //             let fieldsetUpdate = document.querySelector('fieldset.variant-option-size');

  //             fetch(currentUrl)
  //             .then(response => {
  //                 return response.text()
  //             })
  //             .then(html => {
  //                 // Initialize the DOM parser
  //                 const parser = new DOMParser()
  //                 const doc = parser.parseFromString(html, "text/html")
  //                 let incomingSize = doc.querySelector('fieldset.variant-option-size');
  //                 let incomingSelectedSize = incomingSize.querySelector('legend').nextElementSibling;
  //                 let currentSelectedSize = fieldsetUpdate.querySelector('input:checked').nextElementSibling;
  //                 let isSizeDisabled = fieldsetUpdate.classList.contains('size-disabled');
  //                 if(!isSizeDisabled) {
  //                     incomingSize.classList.remove('size-disabled');
  //                     incomingSelectedSize.innerText = currentSelectedSize.textContent;
  //                 }
  //                 fieldsetUpdate.parentNode.replaceChild(incomingSize,fieldsetUpdate);
  //             })
  //             .catch(error => {
  //                 console.error('Failed to fetch page: ', error)
  //             })
  //         }, 200);
  //     })
  // }) 
}

/***/ }),

/***/ "./styles/additional-base.scss":
/*!*************************************!*\
  !*** ./styles/additional-base.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./styles/theme.scss":
/*!***************************!*\
  !*** ./styles/theme.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/common": 0,
/******/ 			"assets/theme": 0,
/******/ 			"assets/additional-base": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkconspire_shopifytheme"] = self["webpackChunkconspire_shopifytheme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/theme","assets/additional-base"], () => (__webpack_require__("./scripts/common.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/theme","assets/additional-base"], () => (__webpack_require__("./styles/additional-base.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/theme","assets/additional-base"], () => (__webpack_require__("./styles/theme.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;